<template>
  <div id="agreements-outer">
    <div id="agreements">

      <el-checkbox
        id="accept-policy_checkbox"
        v-model="acceptPolicy">
        I accept the following booking policies:
      </el-checkbox>
      <div id="validation-fail-accept-policy" v-show="validationFailAcceptPolicy">
        policies must be accepted to complete booking
      </div>

      <div id="agreement-list">
        - A 15% service charge is added to all parties<br/>
        - Parties are not considered ready to be seated until the entire party is present.<br/>
        - Parties won't be seated until the entire party is present<br />
        - Outside food, cakes &amps; drinks cannot be brought into the restaurant<br />
        - Due to our unique seating arrangements, wait times may vary. With a booking you will have the shortest wait time available for your preferred time, but does not guarantee immediate seating.<br/>
        - Multiple reservations made by one group under the same date &amps; time will be treated as separate parties and does not guarantee that they'll be sat near each other. <span style="font-weight: bold;">Management has the right to invalidate reservations that demand to be sat together/near each other.</span> There is no grace period for multi-table parties.<br/>
        - A short grace period past the reserved time is given for the entire party to be present. The length of the grace period will depend on party size and how busy the restaurant is at that time.<br/>
        - No tank tops nor sleeveless shirts/jerseys for men<br />
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  name: "agreements",
  props: [ ],
  data() {
    return {

    }
  },
  computed: {
    validationFailAcceptPolicy() {
      return _.includes( this.$store.state.userInfo.validationFailure, 'policyAccepted' )
    },
    acceptPolicy: {
      get() {
        return this.$store.state.userInfo.agreementsAccepted
      },
      set( val ) {
        this.$store.commit( 'userInfo/UPDATE_ACCEPT_POLICY', val )
        this.validate()
      }
    }
  },
  methods: {
    validate() {
      if ( this.$store.state.userInfo.validationFailure.length > 0 ) {
        this.$store.dispatch( 'userInfo/validate' )
      }
    },
  }
}

</script>

<style scoped lang="scss">

#agreements-outer {
  margin-top: 10px;
  width: 65%;
  display: inline-block;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

#agreements {
  margin-left: auto;
  margin-right: auto;
}

#agreement-list {
  text-align: left;
  font-size: 85%;
}

#accept-policy_checkbox {
  margin-top: 5px;
}

#validation-fail-accept-policy-outer {
  width: 100%;

}

#validation-fail-accept-policy {
  display: inline-block;
  margin: 0 auto 15px auto;
  color: red;
  border: 1px solid red;
  padding: 10px;
  border-radius: 5px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

</style>